<template>
    <span v-if="item">
        <button type="button" @click="editMapping()" size="sm" class="btn-active btn btn-sm btn-primary">Edit</button>
        <button type="button" @click="toggleActive()" size="sm" :class="('btn-active btn btn-sm btn-'+(item.isActive?'danger':'primary'))">{{item.isActive?'Disable':'Activate'}}</button>
        <button type="button" @click="toggleDelete()" size="sm" :class="('btn-active btn btn-sm btn-'+(item.isDeleted?'danger':'primary'))">{{item.isDeleted?'unDelete':'Delete'}}</button>
    </span>
</template>
<style scoped>
    .btn-paid{
        min-width:110px;
    }
    .btn-premium{
        min-width:130px;
    }
    .btn-active{
        min-width:100px;
    }
</style>
<script>
import Vue from "vue";
import HttpFactory from '@/mixins/http.factory';
export default Vue.extend({
    mixins:[HttpFactory],	
    data() {
        return {
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        editMapping(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn(_self.params);  
        },
        toggleActive(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn1(_self.params);
        },
        toggleDelete(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn2(_self.params);
        }
    }
});
</script>
